import styled from "styled-components";
import { colors } from "../../../theme/theme";

export const ContentErrorMessage = styled.div`
	display: flex;
	    align-items: center;
	    justify-content: space-between;
	    padding: 8px 16px;
	
	p {
		margin: 0;
		line-height: 32px;
	}
	
	.close {
		margin-left: auto;
		min-width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`
